import {Col, Row} from "react-bootstrap";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import SortIcon from "@material-ui/icons/Sort";
import {useState} from "react";
import CreateOrders from "./CreateOrders";
import FilterModal from "./FilterModal";
import {useDispatch} from "react-redux";
import {fetchOrders} from "../../../redux/slices/orders";

export default function Subheader() {
    const dispatch = useDispatch();
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)

    const handleCreateOrderModalClosing = () => setIsCreateModalOpen(false)
    const handleCreateOrderModalOpening = () => setIsCreateModalOpen(true)
    const handleFilterOpening = () => setIsFilterModalOpen(true)
    const handleFilterClosing = () => setIsFilterModalOpen(false)

    const handleFilterSetting = (filter) => {
        dispatch(fetchOrders({filter: filter}))
    }

    return (
        <section>
            <Row>
                <Col>
                    <h3>
                        Les commandes
                    </h3>
                </Col>
                <Col className='col-auto ml-auto'>
                    <Button variant='contained' color='primary' onClick={handleCreateOrderModalOpening}>
                        Créer
                        <AddIcon/>
                    </Button>
                </Col>
                <Col className='col-auto ml-auto'>
                    <Button variant='contained' color='primary' onClick={handleFilterOpening}>
                        Filtre
                        <SortIcon/>
                    </Button>
                </Col>
            </Row>

            {
                isCreateModalOpen && (
                    <CreateOrders show={isCreateModalOpen} onClose={handleCreateOrderModalClosing}/>
                )
            }
            <FilterModal show={isFilterModalOpen} onClose={handleFilterClosing} onSet={handleFilterSetting}/>
        </section>
    )

}